const HealthPage = () => <div />;

export default HealthPage;
